import { studentActionPlansQueryOptions } from '@features/action-plans/queries';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/students/$studentNo/action-plans/academic-support')({
    component: Outlet,
    loader: async ({ context, params }) => {
        await context.queryClient.ensureQueryData(studentActionPlansQueryOptions(params.studentNo));
        return null;
    },
});
